import Equifax from "../../assets/company-logos/Equifax.png";
import Experian from "../../assets/company-logos/Experian.png";
import DataAxle from "../../assets/company-logos/dataaxle.png";
import OpenCorporates from "../../assets/company-logos/OpenCorporates.png";
import TransUnion from "../../assets/company-logos/TransUnion.png";
import Creditsafe from "../../assets/company-logos/Creditsafe.png";
import Cortera from "../../assets/company-logos/Cortera.png";
import Everstring from "../../assets/company-logos/Everstring.png";
import Accutrend from "../../assets/company-logos/Accutrend.svg";
import Attom from "../../assets/company-logos/Attom.png";

const data = {
  usecaseInfo: {
    name: "Optimize Business Decisioning",
    description: "A single platform to onboard, profile, and decision on businesses.",
  },
  recipesInfo: {
    title: "Improve business risk management",
    description:
      "Access API-ready solutions for business registry, financials, liens and judgments, filings, credit risk, key contacts, and digital presence.",
  },
  recipes: [
    {
      type: "Business Data",
      title: "Business Firmographics",
      description:
        "Pull SIC and NAICS codes, annual sales revenue, number of employees, business start year, and contact details.",
    },
    {
      type: "Business Data",
      title: "Business Financials",
      description:
        "Gather business credit information, firmographics, liens, and judgments, about a business to expedite risk assessment.",
    },
    {
      type: "Business Data",
      title: "Judgement Counts",
      description: "Assess the financial health of a business by examining raw judgments data.",
    },
    {
      type: "Business Data",
      title: "US Business Registration Check",
      description:
        "Verify government ID Number (e.g., US EIN, ABN), and address across public and private databases.",
    },
    {
      type: "Business Data",
      title: "US Business Contacts",
      description: "Identify the directors (CEO, CFO, President, etc.) associated with a business.",
    },
    {
      type: "Business Data",
      title: "Business Website Lookup (US)",
      description:
        "Identify the website associated with a business to assess its digital presence.",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],

  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "DataAxle",
        img: DataAxle,
      },
      {
        name: "OpenCorporates",
        img: OpenCorporates,
      },
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "TransUnion",
        img: TransUnion,
      },
      {
        name: "Creditsafe",
        img: Creditsafe,
      },
      {
        name: "Cortera",
        img: Cortera,
      },
      {
        name: "Everstring",
        img: Everstring,
      },
      {
        name: "accutrend",
        img: Accutrend,
      },
      {
        name: "Attom",
        img: Attom,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Business Judgment Monitoring Made Frictionless",
      url: "https://demyst.com/blog/business-judgment-monitoring-made-frictionless",
      featured_image: "https://cdn.buttercms.com/m604YfxnQPaZmngi3ejJ",
      date: "2021-10-16",
      description:
        "The legacy systems and processes that have traditionally been used for onboarding purposes are cumbersome, time consuming, and costly. Consequently, financial institutions (FIs) have begun overhauling their strategies to facilitate digital transformation.",
      more: "",
    },
  ],
};

export default data;
